import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FaEye } from 'react-icons/fa';
const buttonStyle = {
    backgroundColor: 'transparent',
    border: 'none',
    width: '20px',
    height: '20px',
    margin: 'auto',
};
function getStyle(display, key) {
    return display[key]
        ? {
            opacity: 1,
            strokeWidth: '1px',
        }
        : {
            opacity: 0.1,
        };
}
export default function ShowHideSpectrumButton({ data, onChangeVisibility, }) {
    return (_jsxs("div", { children: [_jsx(DisplayButtons1D, { data,
                onChangeVisibility }), _jsx(DisplayButtons2D, { data,
                onChangeVisibility })] }));
}
function DisplayButtons1D(props) {
    const { data, onChangeVisibility } = props;
    if (data.info.dimension !== 1) {
        return null;
    }
    const display = data.display;
    return (_jsx("button", { "data-test-id": "hide-show-spectrum-button", style: buttonStyle, type: "button", onClick: (e) => {
            e.stopPropagation();
            onChangeVisibility(data, 'isVisible');
        }, children: _jsx(FaEye, { style: {
                ...getStyle(display, 'isVisible'),
                fill: display.color,
                margin: 'auto',
            } }) }));
}
function DisplayButtons2D(props) {
    const { data, onChangeVisibility } = props;
    if (data.info.dimension !== 2) {
        return null;
    }
    const display = data.display;
    return (_jsxs("div", { style: { minWidth: '40px' }, children: [_jsx("button", { style: buttonStyle, type: "button", onClick: (e) => {
                    e.stopPropagation();
                    onChangeVisibility(data, 'isPositiveVisible');
                }, children: _jsx(FaEye, { style: {
                        ...getStyle(display, 'isPositiveVisible'),
                        fill: display.positiveColor,
                        margin: 'auto',
                    } }) }), _jsx("button", { style: buttonStyle, type: "button", onClick: (e) => {
                    e.stopPropagation();
                    onChangeVisibility(data, 'isNegativeVisible');
                }, children: _jsx(FaEye, { style: {
                        ...getStyle(display, 'isNegativeVisible'),
                        fill: display.negativeColor,
                        margin: 'auto',
                    } }) })] }));
}
